import { Accordion, Box, Button, Grid, List, ListItem, Stack, TableCell, TableRow, TextField, Typography } from '@mui/material';
import styled from 'styled-components';

import { SimpleTreeView } from '@mui/x-tree-view';
import { colorTheme, extraColor, muiTheme } from './muiTheme';

export const Wrapper = styled.div`
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  flex-direction: column;
`;

export const ViewHeightWrapper = styled(Wrapper)`
  height: 100vh;
`;

export const CommonButtonWrapper = styled(Stack)`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
`;

export const LocalTabContent = styled.div`
  overflow: auto;
  padding: 0px 10px 0px;
  margin: 0px -20px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const PageContent = styled(LocalTabContent)`
  && {
    height: auto;
  }
`;

export const ScrollPageContent = styled(LocalTabContent)`
  height: calc(100vh - 210px);
`;

export const WrapContent = styled.div`
  white-space: pre-line;
`;

export const Width180 = styled.div`
  width: 180px;
`;

export const borderStyle = `1px solid ${muiTheme.palette.common.black}`;

export const Link = styled.a`
  color: ${muiTheme.palette.primary.light};
  font-weight: 500;
`;

export const CreditReportSection = styled.section`
  text-align: right;
  margin-bottom: 10px;
`;

export const AddReminderTextField = styled(TextField)`
  height: 50px;
  border: none;
  outline: none;
  border-radius: 20px;
`;

export const TypographyAddReminder = styled(Typography)`
  width: 30%;
  margin-top: 4px;
`;

export const AddReminderLabel = styled(TypographyAddReminder)`
  margin-top: -117px;
`;

export const PersonalInfoName = styled.div`
  width: 36%;
  display: flex;
  justify-content: space-between;
`;

export const PersonalInfoDob = styled(PersonalInfoName)`
  width: 50%;
`;

export const StipReviewGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StipReviewGridVertical = styled(StipReviewGrid)`
  vertical-align: 'center';
`;

export const EditProductBoxWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding: 24px;
`;

export const EditRetaiFormWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 60%;
  margin-left: 20px;
  margin-top: 42px;
`;

export const EditRetailButtonWrapper = styled(Box)`
  position: absolute;
  right: 40px;
  top: 65px;
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 170px;
  left: 200px;
`;

export const TreeViewComponentWrapper = styled.div<{ isLoading: boolean }>`
  opacity: ${({ isLoading }) => isLoading && 0.5};
  pointer-events: ${({ isLoading }) => isLoading && 'none'};
`;

export const TreeViewItemWrapper = styled(SimpleTreeView)`
  .MuiFormControlLabel-root {
    height: 20px;
  }

  .MuiFormControlLabel-label {
    line-height: 1;
  }

  .MuiTreeItem-content {
    padding: 0;
  }

  flex-grow: 1;
  max-width: 400;
  overflow-y: auto;
  padding: 2px 5px;
  height: 74vh;
  background-color: ${extraColor.palette.grey.light};
`;

export const TextWrapper = styled(Stack)`
  display: flex;
`;

export const TooltipTyporaphy = styled(Typography)<{ line: number; $isBold: boolean; $isWordBreak: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  word-break: ${({ $isWordBreak }) => $isWordBreak && 'break-word'};
  font-weight: ${({ $isBold }) => $isBold && 'bold !important'};

  ${({ line }) =>
    line > 1
      ? `
      white-space: normal;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: ${line};
      line-clamp: ${line};
    `
      : ''}
`;

export const Cell = styled(TableCell)`
  display: table-cell;
  vertical-align: baseline;
  padding: 8px;
`;

export const HeaderText = styled(Typography)`
  white-space: nowrap;
  text-decoration: underline;
  font-weight: bold;
`;

export const RowText = styled(Typography)`
  word-break: break-all;
`;

export const StyledTableRow = styled(TableRow)<{ index: number }>`
  background: ${({ index }) => (index % 2 ? colorTheme.palette.secondary.main : colorTheme.palette.common.white)};
`;

export const StyledTableHead = styled(TableRow)`
  background: ${colorTheme.palette.secondary.main};
  position: sticky;
  top: -10px;
  z-index: 1;
  p {
    font-weight: bold !important;
  }
`;

export const StyledCreditReportWrapper = styled(Box)`
  font-size: 11px;

  h3 {
    font-size: 16px;
  }

  p,
  div,
  span,
  h4 {
    font-size: 11px;
    font-weight: 600;
  }

  .MuiDataGrid-columnHeaderTitleContainerContent > p {
      font-weight: 700 !important;
  } 
`;

export const ContactManagerContentWraper = styled(Grid)`
  margin-bottom: 0px !important;
`;

export const DiscStyleList = styled(List)`
  list-style: decimal;
  margin-left: 30px;
`;

export const DiscStyleListItem = styled(ListItem)`
  display: list-item;
  padding: 5px 0;
`;

export const HTMLFileWrapper = styled(Box)`
  max-height: 77vh;
  overflow: auto;
  padding: 0 10px 10px 10px;
`;

export const StyledNewTabButton = styled(Button)`
  padding: 0;
  min-width: 32px;

  span {
    margin: 0;
  }
`;

export const BorderWrapper = styled(Box)`
  border: 1px solid ${colorTheme.palette.secondary.dark};
  border-radius: 4px;
`;

export const DictionaryAccordianWrapper = styled(Accordion)`
  box-shadow: none;
  border-bottom: 1px solid ${muiTheme.palette.divider};
  border-radius: 0px;
`;